(function ($) {
	// Change class for window size
	var win = $(window);
	win.bind("load resize", init);
	function init() {
		var windowWidth = win.width(),
			windowSm = 999;
		if (windowWidth <= windowSm) {
			$("body").removeClass("pc");
			$("body").addClass("sp");
		} else {
			$("body").removeClass("sp");
			$("body").addClass("pc");
		}
	}

	// Fix Header
	var win = $(window),
		header = $("#js-head"),
		startPos = 0;
	win.scroll(function () {
		var currentPos = $(this).scrollTop();
		if (win.scrollTop() > 110) {
			header.addClass("fixed");
		} else {
			header.removeClass("fixed");
		}
		startPos = currentPos;
	});

	// Nav Toggle Button
	var state = false,
		html = $("html"),
		spbody = $("body.sp"),
		navbtn = $("#js-navbtn"),
		navwrap = $("#js-wrap");
	navbtn.click(function () {
		header.toggleClass("open");
		navbtn.toggleClass("open");
		navwrap.toggleClass("open");
		if (state == false) {
			scrollpos = win.scrollTop();
			html.addClass("scroll-prevent");
			spbody.addClass("fixed").css({ top: -scrollpos });
			state = true;
		} else {
			html.removeClass("scroll-prevent");
			spbody.removeClass("fixed").css({ top: 0 });
			win.scrollTo(0, scrollpos);
			state = false;
		}
	});

	// Navigation
	var win = $(window),
		menu = $(".c-gnav li.main"),
		mnlink = $(".c-gnav li.main a"),
		submenu = $(".c-gnav .sub li a");
	win.bind("load resize", init);
	function init() {
		var windowWidth = win.width(),
			windowSm = 999;
		if (windowWidth <= windowSm) {
			mnlink.on("click", function () {
				navbtn.click();
			});
		} else {
			menu.hover(
				function () {
					$(this).addClass("visible");
					$(this).children(".sub").addClass("visible");
				},
				function () {
					$(this).removeClass("visible");
					$(this).children(".sub").removeClass("visible");
				}
			);
			menu.on("click", function () {
				$(this).removeClass("visible");
				$(this).children(".sub").removeClass("visible");
			});
		}
	}

	// Current Page
	$(".c-gnav a").each(function () {
		var $href = $(this).attr("href");
		if (location.href.match($href)) {
			$(this).parent().addClass("active");
		} else {
			$(this).parent().removeClass("active");
		}
	});

	$('a[href^="#"]').each(function () {
		if (this.href == location.href) {
			$(this).parent().addClass("active");
		} else {
			$(this).parent().removeClass("active");
		}
	});

	// ホームからクラス削除
	$(".c-gnav li.main:first-child").each(function () {
		if ($(this).hasClass("active")) {
			$(this).removeClass("active");
		}
	});

	// Smooth Scroll
	var headerHeight = $("#js-head").outerHeight(),
		speed = 500,
		urlHash = location.hash;
	if (urlHash) {
		$("body,html").stop().scrollTop(0);
		setTimeout(function () {
			var target = $(urlHash),
				position = target.offset().top - headerHeight;
			$("body,html").stop().animate(
				{
					scrollTop: position,
				},
				speed,
				"swing"
			);
		}, 100);
	}
	$('a[href^="#"]').click(function () {
		var href = $(this).attr("href"),
			target = $(href),
			position = target.offset().top - headerHeight;
		$("body,html").stop().animate(
			{
				scrollTop: position,
			},
			speed,
			"swing"
		);
	});

	// disabled Links
	$("a.js-disable").click(function () {
		return false;
	});

	// touchmove handler
	var linkTouchStart = function () {
		thisAnchor = $(this);
		touchPos = thisAnchor.offset().top;
		moveCheck = function () {
			nowPos = thisAnchor.offset().top;
			if (touchPos == nowPos) {
				thisAnchor.addClass("hover");
			}
		};
		setTimeout(moveCheck, 100);
	};
	var linkTouchEnd = function () {
		thisAnchor = $(this);
		hoverRemove = function () {
			thisAnchor.removeClass("hover");
		};
		setTimeout(hoverRemove, 500);
	};
	$(document).on("touchstart mousedown", "a", linkTouchStart);
	$(document).on("touchend mouseup", "a", linkTouchEnd);
})(jQuery);
